import { z } from 'zod';
export const pipelineListQuerySchema = z.object({
    project_id: z.string().uuid(),
});
export const pipelineBoardQuerySchema = z.object({
    project_id: z.string().uuid(),
});
export const pipelineForecastQuerySchema = z.object({
    project_id: z.string().uuid(),
    pipeline_id: z.string().uuid().optional(),
});
//# sourceMappingURL=pipeline.js.map